import { render, staticRenderFns } from "./Readme.vue?vue&type=template&id=8e7c70ae&scoped=true"
import script from "./Readme.vue?vue&type=script&lang=js"
export * from "./Readme.vue?vue&type=script&lang=js"
import style0 from "./Readme.vue?vue&type=style&index=0&id=8e7c70ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e7c70ae",
  null
  
)

export default component.exports